export default "__VITE_ASSET__DTbE7SqK__"